.buttons {
  display: flex;
  justify-content: flex-end;
}
